import React, { createContext, useContext } from "react";
import { rootStore as storeInstance } from "./rootStore";

const RootStoreContext = createContext(storeInstance);

export const RootStoreProvider = ({ children }) => {
  return (
    <RootStoreContext.Provider value={storeInstance}>
      {children}
    </RootStoreContext.Provider>
  );
};

export const useRootStore = () => useContext(RootStoreContext);
